import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import GeneralView from '@/views/GeneralView.vue'
import CreateReportView from '@/views/CreateReportView.vue'
import store from '@/store'
import { ConnectionWSShared } from '@leapsight/styleguide'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/portal',
    name: 'login'
  },  
  {
    path: '/reports',
    name: 'GeneralView',
    component: GeneralView,
    meta: {
      requiresAuth: true
    },
    
    children: [ 
      {
        path: 'new',
        name: 'New',
        component: CreateReportView,
        meta: {
          requiresAuth: true
        },
      },
      { path: '', redirect: { name: 'List' } },
      // {
      //   path: 'config',
      //   name: 'configView',
      //   component: GeneralView,
      //   children: [
      //     {
      //       path: '',
      //       name: 'Config',
      //       props: true,
      //       component: () =>
      //         import(
      //           '../views/ConfigView.vue'
      //         )            
      //     }
      //   ]
      // },  
      {
        path: 'processing',
        name: 'Processing',
        component: GeneralView,
        children: [ 
          {
            path : '',
            props : true,
            component: () =>
            import(
              '../views/Processing.vue'
            ),            
          },
        ]
      },      
      {
        path: 'lista',
        name: 'List',
        component: GeneralView,
        children: [ 
          {
            path : '',
            props : true,
            component: () =>
            import(
              '../views/ReportList.vue'
            ),            
          },
          {
            path : ':id_informe',
            props : true,
            component: () =>
            import(
              '../views/Results.vue'
            ),      
          }
        ]
      },
       {
         path: 'programas',
        name: 'Programs',
         component: GeneralView,
         children: [ 
           {
             path : '',
             props : true,
             component: () =>
             import(
               /* '../views/ListProgramas.vue' */
               '../views/ProgramList.vue'
             ),            
           },
         ]
       },      
    ]
  }  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Antes de ingresar a cualquier ruta verifica si el usuario esta logueado correctamente
    if (store.getters['auth/isLoggedIn']) {
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        // Verifica rol del usuario antes de ingresar a rutas que requieren ser admin
        if (store.getters.isAdmin) next()
        //En caso que no se admin redirigo a vista principal
        else next({ name: 'GeneralView' })
      } else next()
    } else window.location.assign(`${window.location.origin}/portal/login`)
  } else next()
})

window.addEventListener('beforeunload', event => {
  ConnectionWSShared.closeConnection()
})

export default router
